module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/icon_doctor-fedcb65d7c4cb9d939a5851b88b0e70a.png";